/* Auto-generated from type-schema.proto */
export enum TypeCategory {
    Undefined = 0,
    Schema = 1,
    Boolean = 2,
    Number = 3,
    String = 4,
    Buffer = 5,
    Function = 6
}
export interface ISchemaRef {
    name?: string;
    path?: string;
}
export interface IType {
    category?: TypeCategory;
    schema?: ISchemaRef;
    nestedArrayLevel?: number;
}
